module.exports = __webpack_public_path__ + "media/theme/favicon_new-01-5d503123.png";